<div class="content-area">
  <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Rechnungen</h2>
  <button class="btn btn-success btn-sm" (click)="exportToExcel(invoices)">Download .xlsx ({{ status }})</button>

  <clr-datagrid [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'number'" [clrDgSortOrder]="descSort">Rechnung</clr-dg-column>
    <clr-dg-column [clrDgField]="'project_id'">Jobnummer</clr-dg-column>
    <clr-dg-column [clrDgField]="'order_id'">Bestellnummer</clr-dg-column>
    <clr-dg-column [clrDgField]="'company_name'">Kunde/Betreff</clr-dg-column>
    <clr-dg-column [clrDgField]="'dateI'">Datum</clr-dg-column>
    <clr-dg-column [clrDgField]="'dateII'">Fälligkeit</clr-dg-column>
    <clr-dg-column [clrDgField]="'status'">Status</clr-dg-column>
    <clr-dg-column>Betrag (netto)</clr-dg-column>
    <clr-dg-column>Betrag (brutto)</clr-dg-column>
    <clr-dg-column>Skonto (brutto)</clr-dg-column>
    <clr-dg-column>Bezahlt (brutto)</clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Invoice!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let invoice of invoices">
      <clr-dg-cell [routerLink]="['/invoice/details', invoice.praefix, invoice.number]">{{ invoice.praefix }}.{{ invoice.number }}</clr-dg-cell>
      <clr-dg-cell [routerLink]="['/job/details', invoice.project_id, invoice.job_id]">{{ invoice.project_id }}.0006.{{ invoice.job_id }}</clr-dg-cell>
      <clr-dg-cell>{{ invoice.order_id }}</clr-dg-cell>
      <clr-dg-cell><b>{{ invoice.company_name }}</b><br />{{ invoice.name_project }}<br />{{ invoice.description }}</clr-dg-cell>
      <clr-dg-cell>{{ invoice.dateI | date: 'dd.MM.yyyy' }}</clr-dg-cell>
      <clr-dg-cell>{{ invoice.dateII | date: 'dd.MM.yyyy' }}</clr-dg-cell>
      <clr-dg-cell  [className]="findButtonClass(invoice.status)" role="alert">
        <div class="alert-items">
          <div class="alert-item static">
            <span class="alert-text">{{ getCellStatus(invoice.status).statusDisplay}}</span>
          </div>
        </div>
      </clr-dg-cell>
      <clr-dg-cell class="currency">{{ invoice.brutto/1.19 | currency: 'EUR':'code':'1.2-2':'de' }}</clr-dg-cell>
      <clr-dg-cell class="currency"><b>{{ invoice.brutto | currency: 'EUR':'code':'1.2-2':'de' }}</b></clr-dg-cell>
      <clr-dg-cell class="currency">{{ invoice.skonto  | currency: 'EUR':'code':'1.2-2':'de' }}</clr-dg-cell>
      <clr-dg-cell class="currency">{{ invoice.paid  | currency: 'EUR':'code':'1.2-2':'de' }}</clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="50">
        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Rechnungen pro Seite</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
        von  {{ invoices.length }} Rechnung(en)
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>
</div>
